<!--
   Created by qing on 2020/2/19 2:15 下午
   Des:
-->
<template>
  <div v-if="filterWay">
    <SelectValue
      :disabled="disabled"
      :fields="fields"
      :isMultiple="isMultiple"
      :filterValue="current"
      :filter="filter"
      :formId="formId"
      @change="filterChange">
    </SelectValue>
  </div>

  <div v-else class="filter-sliding-block">
    <van-slider
      v-model="current[0]"
      :disabled="disabled"
      :max="field.maxValue"
      :min="field.minValue"
      :step="field.step"
	  active-color="#32D071"
      @change="filterChange">
      <div
        slot="button"
        class="custom-button">
        {{ current[0] }}
      </div>
    </van-slider>
  </div>

</template>

<script>
  import current from "./mixin"
  export default {
    mixins: [current],
    data() {
      return {};
    }
  };
</script>

<style lang="less">

  .filter-sliding-block {
    width: 200px;

    .van-slider {
      width: 100%;

    }
  }

</style>
